import React from 'react';

import { CURATOR_ICONS } from '@/shared/components/CuratorIcon';
import { getVaults } from '@/features/vaults/utils/getVaults';
import { RESTAKE_SUPPORTED_NETWORKS } from '@/core/config';
import { CuratorID } from '@/features/vaults/types/CuratorID';

const curatorsOriginalSortedList: CuratorID[] = [
  'infStones',
  'nexo',
  'luganodes',
  'mevcapital',
  'hyve',
  'proviroll',
  'quasar',
  're7labs',
  'renzo',
  'gauntlet',
  'stakecapital',
  'stakefish',
  'a41',
  'steakhouse',
  'ibtc',
  'infrasingularity',
  'bima',
  'dsrv',
  'nodes.guru',
  'hashkey',
  'republic',
  'rockx',
  'p2p',
  'chorusone',
  'cosmostation',
  'cp0x',
];

const allVaults = getVaults(RESTAKE_SUPPORTED_NETWORKS);
for (const vault of allVaults) {
  for (const curator of vault.curators) {
    if (!CURATOR_ICONS[curator]) {
      continue;
    }
    if (!curatorsOriginalSortedList.includes(curator)) {
      curatorsOriginalSortedList.push(curator);
    }
  }
}

export const curatorsList: React.ReactNode[] = curatorsOriginalSortedList.map(
  key => CURATOR_ICONS[key],
);
